import {EContentService} from "../../../globals/services/enhancedContent.service";
import { ReactComponent as FolderIcon } from '../../../assets/images/folder.svg';
import React, {useEffect, useState} from "react";
import {Input, Label, Table} from "reactstrap";

export const FolderList = (props) => {
    const {action} = props;
    const eContentService = EContentService();
    const [list, setList] = useState([]);
    const [nonFilterItems, setNonFilterItems] = useState([]);
    const [filterStatus, setFilterStatus] = useState('All');
    const [value, setValue] = useState('');

    useEffect(() => {
        eContentService.getSHIHRFolderList().then((res) => {
            setList(res.data);
            setNonFilterItems(res.data);
        });
    }, [value]);


    const handleEdit = (e, item) => {
        action(item);
    }

    const filterByName = (e, key, value) => {
        if (value.length>2) {
            setFilterStatus('All');
            const _items = list.filter(i => i.title.toLowerCase().includes(value.toLowerCase()))
            setList(_items)
        } else if (value.length===0) {
            setList(nonFilterItems)
        }
    }

    const filterData = (e, key, value) => {
        setFilterStatus(value);
        if (value==='All') {
            setList(nonFilterItems)
        } else {
            const _items = [...nonFilterItems].filter(i => i.status===value)
            setList(_items)
        }
    }


    return (
        <div className="FolderList">
            <h1>Folder List</h1>
            <div className="row mb-2">
                <div className="col-9 d-flex">

                    <div className="form-group col-md-3 mr-2">
                        <h5 className="mt-4"> <Label htmlFor="_name">Name</Label></h5>
                        <Input
                            id="searchName"
                            name="searchName"
                            placeholder="filter by name..."
                            type="text"
                            onChange={(e) => filterByName(e, 'name', e.target.value)}
                        />
                    </div>

                    <div className="form-group col-md-2">
                        <h5 className="mt-4"> <Label htmlFor="_mobile">Status</Label></h5>
                        <select className="form-control" id="exampleFormControlSelect1"  value={filterStatus} onChange={(e)=>filterData(e, 'status', e.target.value)}>
                            <option value="All">All</option>
                            <option value="Active">Active</option>
                            <option value="Suspended">Suspended</option>
                            <option value="Draft">Draft</option>
                        </select>
                    </div>


                </div>
            </div>
            <Table responsive>
                <thead>
                <tr>
                    <th>
                        Title
                    </th>
                    <th>
                        Status
                    </th>
                    <th>
                        Items
                    </th>
                    <th>
                        Edit
                    </th>

                </tr>
                </thead>
                <tbody>
                {
                    list && list.sort((a, b) => a.title.localeCompare(b.title))
                        .map((item, index) => {
                        return (
                            <tr key={item._id}>
                                <td className="mr-2"><FolderIcon />{item.title}</td>
                                <td>{item.status}</td>
                                <td>{item.contentItems.length}</td>
                                <td><button className="listCTA" onClick={(e)=>handleEdit(e, item)}>Edit</button></td>
                            </tr>
                        )
                    }, [])
                }
                </tbody>
            </Table>

        </div>
    )
}